module.exports = __webpack_public_path__ + "img/guarantee-authentic.863ae461.png";